import { classes, Text } from "@alpacahq/ui/old";

import { FEATURES } from "./constant";

export const PlanTable = () => (
  <>
    {FEATURES.map((feature, featureIndex, featureArray) => (
      <div key={feature.title?.toString()}>
        <div
          className={classes(
            "w-full bg-gray-200 px-6 py-4",
            featureIndex === 0 && "rounded-t",
          )}
        >
          <Text className="font-bold text-base">{feature.title}</Text>
        </div>

        {feature.items.map((item, itemIndex, itemArray) => (
          <div
            key={item.title?.toString()}
            className={classes(
              "grid grid-cols-3 border-gray-200 border-x",
              itemIndex > 0 && "border-t",
              featureArray.length - 1 === featureIndex &&
                itemArray.length - 1 === itemIndex &&
                "rounded-b border-b",
            )}
          >
            <div className="flex w-full max-w-80 items-center justify-start">
              <Text className="px-2 py-4 font-semibold text-sm md:px-6">
                {item.title}
              </Text>
            </div>

            {(
              [
                { planKey: "basic" as const, plan: item.plans[0] },
                { planKey: "elite" as const, plan: item.plans[1] },
              ] as const
            ).map(({ planKey, plan }) => (
              <div
                key={planKey}
                className={classes(
                  "flex w-full max-w-80 items-center justify-center bg-gray-100 py-4 text-center text-sm md:px-2",
                  planKey === "basic" && "border-gray-200 border-r",
                )}
              >
                {plan}
              </div>
            ))}
          </div>
        ))}
      </div>
    ))}
  </>
);
